import React from "react";
import { Link, useNavigate } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";

const PushNotificationModal = ({ isOpen, onClose, selectedBanner }) => {
  const navigate = useNavigate();
  if (!isOpen || !selectedBanner) return null;

  const handleBannerClick = (e) => {
    e.preventDefault();
    onClose();
    if (selectedBanner.banner_link) {
      navigate(selectedBanner.banner_link);
    }
  };

  return (
    <div
      className="SB-modal SB-pushNotification-modal open"
      id="SB-pushNotification-modal"
      onClick={onClose}
    >
      <div className="SB-modal-dialog">
        <div className="SB-modal-content">
          <div className="SB-modal-close SB-iconSVG" onClick={onClose}  title="close">
              <svg xmlns="http://www.w3.org/2000/svg">
                <use xlinkHref={`${icons}#${"icon-close"}`} />
              </svg>
          </div>
          <div className="SB-modal-body">
            <div className="SB-pushNotification">
              <Link
                to={selectedBanner.banner_link || "/"}
                onClick={handleBannerClick}
              >
                <img
                  src={selectedBanner.imagepath}
                  alt={selectedBanner.banner_name}
                  loading="lazy"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationModal;
